import { request } from '../request'

// 获取计划任务列表
export interface GetJobList {
  limit: number
  page: number
  keyword?: string
  start_time?: string
  end_time?: string
  scheduler_type?: string | number //执行类型
  biz_area?: string //安全域
}
export const getJobList = (data: GetJobList) =>
  request('/portal/verify/endpointSecurity/jobList', {
    params: {
      ...data,
    },
  })

// 获取安全域列表
export const getBizAreaList = () => request('/portal/verify/endpointSecurity/jobBizAreaList')

// 获取计划详情
export interface GetJobDetail {
  id: string
}
export const getJobDetail = (data: GetJobDetail) =>
  request('/portal/verify/endpointSecurity/jobDetail', {
    params: {
      ...data,
    },
  })

// 暂停/重启 计划任务
export interface ChangeJobStatus {
  id: string
  task_status: number
}
export const changeJobStatus = (data: ChangeJobStatus) =>
  request('/portal/verify/endpointSecurity/changeJobStatus', {
    method: 'PUT',
    data,
  })

// 删除计划任务列表
export interface DeleteTask {
  id: string
}
export const deleteTask = (data: DeleteTask) =>
  request('/portal/verify/endpointSecurity/deleteJob', {
    method: 'delete',
    data,
  })

// 批量删除计划任务列表
export interface BatchDeleteJob {
  id_list: string[]
}
export const batchDeleteJob = (data: BatchDeleteJob) =>
  request('/portal/verify/endpointSecurity/batchDeleteJob', {
    method: 'delete',
    data,
  })
